import React from 'react';
import ReactDOM from 'react-dom/client'; 
import { MsalProvider } from '@azure/msal-react';
import { getMsalConfig } from './auth/msalConfig'
import { PublicClientApplication } from '@azure/msal-browser';
import App from './App';
import { UserProvider } from './contexts/UserContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { loadConfig, getConfig } from './services/configService';

/**
 * Initialize application with config loading
 * This ensures config.json is loaded before any authentication is attempted
 */
const initializeApp = async () => {
  try {
    // Load config as the first step
    await loadConfig();

    // Initialize MSAL with loaded config
    const msalConfig = getMsalConfig();
    const msalInstance = new PublicClientApplication(msalConfig);

    // Get config for provider
    const config = getConfig();

    const root = ReactDOM.createRoot(document.getElementById('root')); 
    root.render(
      <ConfigProvider config={config}>
        <MsalProvider instance={msalInstance}>
          <UserProvider>
            <App />
          </UserProvider>
        </MsalProvider>
      </ConfigProvider>
    );
  } catch (error) {
    console.error('Failed to initialize application:', error);
    // Display error message to user
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
        <h1>Application Error</h1>
        <p>Failed to load configuration. Please check the console for details.</p>
      </div>
    );
  }
};

// Start the application initialization
initializeApp();